import { useEffect, useState } from "react";

// Product names by uuid and by its first 8 characters (how verdicts and the
// training status name products). A product saved without a name shows its EAN.
export function useProductNames(api) {
  const [names, setNames] = useState({});
  useEffect(() => {
    let cancelled = false;
    api.listProducts().then((list) => {
      const out = {};
      for (const p of list || []) {
        const label = p.product_name || p.ean_code || p.id.slice(0, 8);
        out[p.id] = label;
        out[p.id.slice(0, 8)] = label;
      }
      if (!cancelled) setNames(out);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [api]);
  return names;
}

export function nameOf(names, id) {
  if (!id) return "—";
  return names[id] || names[String(id).slice(0, 8)] || String(id).slice(0, 8);
}
